/*
 * @Author: Teemo Ding
 * @Date: 2021-12-23 17:29:22
 * @LastEditTime: 2022-01-07 11:39:18
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/SubscriptionBuy/SubscriptionBuyEdit/tools.ts
 */
export const breadcrumbData = (subscriptionNo, { getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/order/subscriptionBuy/list',
    name: getI18n('general.subscriptionBuy'),
  },
  {
    url: '',
    name: `#${subscriptionNo}`,
  },
];
